import { theme } from 'components';
import * as React from 'react';
import styled from 'styled-components';
import { buildCssProps } from 'utils';

type ToggleProps = {
  onClick: (event: React.MouseEvent) => void;
  onChange?: (event: React.FormEvent<HTMLInputElement>) => void;
  model: boolean;
  dataCy?: string;
  disabled?: boolean;
};

const Toggle = ({
  model,
  onClick,
  onChange,
  dataCy,
  disabled,
}: ToggleProps) => (
  <>
    <input
      checked={model}
      style={{ margin: 0 }}
      onChange={onChange}
      className="form-control react-toggle"
      type="checkbox"
      readOnly
      disabled={disabled}
    ></input>
    <StyledLabel
      $disabled={disabled}
      onClick={disabled ? undefined : onClick}
      data-cy={dataCy}
      data-cy-toggle={model ? 'on' : 'off'}
    >
      Toggle
    </StyledLabel>
  </>
);

export default Toggle;

const StyledLabel = styled.label<{ $disabled?: boolean }>`
  &&&& {
    ${({ $disabled }) =>
      buildCssProps([
        ['opacity', $disabled && theme.switchDisabledOpacity],
        ['background-color', $disabled && theme.disabledColor],
        ['cursor', $disabled && 'not-allowed'],
      ])}
  }
`;
